import type { ReactNode } from 'react';

/**
 * Pill-shaped toggle for filter rows. The "active / inactive" visual
 * pattern was open-coded 5+ times across pages (Feedback / Devices /
 * UsersPage quick-filter / AuditLogs since-days / Codes expiration filter);
 * extracting it means flipping the active style in one place updates them all.
 */

interface Props {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  /** Tone affects active background. Default = brand (shark). */
  tone?: 'shark' | 'amber';
  className?: string;
}

const ACTIVE_CLASSES: Record<NonNullable<Props['tone']>, string> = {
  shark: 'bg-shark-500/20 border-shark-500/50 text-shark-200',
  amber: 'bg-amber-500/20 border-amber-500/50 text-amber-200',
};

export function Chip({
  active,
  onClick,
  children,
  tone = 'shark',
  className = '',
}: Props): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
        active
          ? ACTIVE_CLASSES[tone]
          : 'border-white/10 text-slate-400 hover:text-slate-100 hover:border-white/10 bg-white/[0.03]'
      } ${className}`}
    >
      {children}
    </button>
  );
}
